// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2604983a","455":"035cddd2","977":"d454f478"}[chunkId] + ".chunk.js";
};